import { SearchScenarioId, getScenarioStore } from "owa-search-store";
import { type SearchHeaderType } from "../store/schema/SearchHeaderType";

export default function shouldShowModifiedQueryInformationalView(searchHeaderType: SearchHeaderType = 1): boolean {
    const { queryAlterationType } = getScenarioStore(SearchScenarioId.Mail);
    
    return (searchHeaderType === 1 ||
        searchHeaderType === 3 ||
        queryAlterationType === "NoResultFolderRefinerModification");
}
